<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Payrolling Benefits</h1>
    <p>Currently HMRC allow companies to volunteer to payroll company benefits, ahead of mandatory payrolling benefits in 2027. Has your company registered to process comapny benefits through payroll? </p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasPayrolledBenefits">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasPayrolledBenefits">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasPayrolledBenefits === undefined || props.formData.hasPayrolledBenefits === null || props.formData.hasPayrolledBenefits === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}




const executeStep = async () => {
  return true;
}




defineExpose({ validateStep, executeStep });

</script>